export default __webpack_public_path__ + "static/saTechnologies-38191e809030ffa89bcbca480f0e4c62.svg";